export const ADMIN_API_BASE_URL = process.env.REACT_APP_ADMIN_API_BASE_URL || 'https://api-admin.polopan.com';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ADMIN_API_BASE_URL;